export const resetStateSuccess = () => ({
	type: 'RESET_STATE_SUCESS',
});

export default {
	resetStateSuccess,
};
